// extracted by mini-css-extract-plugin
export default {"content":"owner-delete_content__DIqra","buttons":"owner-delete_buttons__TbXT1","button":"owner-delete_button__mfBg7"};